import * as companyData from "./company-data";

/** DANE DO FORMULARZY */

export const KontaktPageFormInfo: ContactFormInfoData = {
  iconClassName: "mail",
  titleFirstLine: "Masz pytania?",
  titleSecondLine: "Zostaw wiadomość!",
  descriptionFirstLine: "Wyślij wiadomość poprzez formularz,",
  descriptionSecondLine: "a skontaktujemy się z",
  descriptionSecondLineBlueWord: "Tobą."
};
export const KontaktPageInitialFormData: FormFieldData[] = [
  {
    fieldOrdinal: 1,
    fieldLabel: "Imię i nazwisko",
    fieldName: "name",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 2,
    fieldLabel: "Email",
    fieldName: "email",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 3,
    fieldLabel: "Firma",
    fieldName: "company",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 4,
    fieldLabel: "Temat",
    fieldName: "subject",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 5,
    fieldLabel: "Wiadomość",
    fieldName: "message",
    fieldValue: "",
    fieldType: "textarea"
  }
];

export const BiuroRachunkowePageFormInfo: ContactFormInfoData = {
  iconClassName: "phone-outline",
  titleFirstLine: "Zadzwoń do nas!",
  titleSecondLine: companyData.FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_PHONE,
  descriptionFirstLine: "Możesz również skontaktować się",
  descriptionSecondLine: "poprzez ",
  descriptionSecondLineBlueWord: "formularz kontaktowy."
};
export const BiuroRachunkowePageInitialFormData: FormFieldData[] = [
  {
    fieldOrdinal: 1,
    fieldLabel: "Imię i nazwisko",
    fieldName: "name",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 2,
    fieldLabel: "Email",
    fieldName: "email",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 3,
    fieldLabel: "Firma",
    fieldName: "company",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 4,
    fieldLabel: "Temat",
    fieldName: "subject",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 5,
    fieldLabel: "Wiadomość",
    fieldName: "message",
    fieldValue: "",
    fieldType: "textarea"
  }
];

export const ZakladanieSpolekZooPageFormInfo: ContactFormInfoData = {
  iconClassName: "phone-outline",
  titleFirstLine: "Zadzwoń do nas!",
  titleSecondLine: companyData.FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_PHONE,
  descriptionFirstLine: "Możesz również skontaktować się",
  descriptionSecondLine: "poprzez ",
  descriptionSecondLineBlueWord: "formularz kontaktowy."
};
export const ZakladanieSpolekZooPageInitialFormData: FormFieldData[] = [
  {
    fieldOrdinal: 1,
    fieldLabel: "Imię i nazwisko",
    fieldName: "name",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 2,
    fieldLabel: "Email",
    fieldName: "email",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 3,
    fieldLabel: "Firma",
    fieldName: "company",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 4,
    fieldLabel: "Temat",
    fieldName: "subject",
    fieldValue: "",
    fieldType: "text-field"
  },
  {
    fieldOrdinal: 5,
    fieldLabel: "Wiadomość",
    fieldName: "message",
    fieldValue: "",
    fieldType: "textarea"
  }
];

/** VALIDATIONS */
export const EMAIL_REGEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


// WEBPACK FOOTER //
// ./src/constants/form-data.ts